"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var anonymousUser = {
  id: '',
  name: 'Anonymous',
  avatar: ''
};

var VotedUsers = function VotedUsers(_ref) {
  var votedUsers = _ref.votedUsers,
      previewCount = _ref.previewCount,
      anonymousLikesCount = _ref.anonymousLikesCount;
  var totalVotedByUsers = votedUsers.length + anonymousLikesCount;
  return (0, _preact.h)("div", {
    className: "topic-voted-users m-v"
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("div", null, votedUsers.slice(0, previewCount).map(function (user) {
      return (0, _preact.h)(_UserAvatar.default, {
        key: user.id,
        disablePopup: true,
        user: user,
        extraClass: "avatar avatar--S",
        showRank: false
      });
    }), votedUsers.length - previewCount > 0 ? (0, _preact.h)("span", {
      className: "text--meta"
    }, "+", totalVotedByUsers - previewCount) : null),
    tooltipMessage: (0, _preact.h)("ul", {
      className: "post-like-list__complete-list"
    }, votedUsers.map(function (votedUser) {
      return (0, _preact.h)("li", {
        key: votedUser.id,
        className: "post-like-list__item"
      }, (0, _preact.h)("a", {
        className: "link",
        href: (0, _absoluteUrlRuntime.resolveUrl)(votedUser.url)
      }, (0, _preact.h)(_UserAvatar.default, {
        user: votedUser,
        extraClass: "avatar avatar--S",
        disablePopup: true,
        showRank: false
      }), (0, _preact.h)("span", null, votedUser.name)));
    }), anonymousLikesCount > 0 && (0, _preact.h)("li", {
      className: "post-like-list__item"
    }, (0, _preact.h)("div", {
      className: "wrapper"
    }, (0, _preact.h)(_UserAvatar.default, {
      user: anonymousUser,
      extraClass: "avatar avatar--S",
      disablePopup: true,
      showRank: false
    }), (0, _preact.h)(_phrase.default, {
      p: "anonymous.users.count",
      count: {
        n: anonymousLikesCount
      },
      renderAsText: true
    }, function (anonymousLikes) {
      return (0, _preact.h)("span", null, anonymousLikes);
    }))))
  }));
};

var _default = VotedUsers;
exports.default = _default;